<div class="image-viewer">
  <div class="image-container">
      <span (click)="closeImage()" class="close-button">
        <i class="fa fa-times-circle"></i>
      </span>
    <img class="image" alt="Image" [src]="image" />
  </div>
</div>
